import { createSvgIcon } from "@mui/material";

export const LayerLogoSymbol = createSvgIcon(
  <svg viewBox="400 400 1200 1200" fill="none">
    <path
      d="M999.936 436V436.169C856.43 658.687 606.151 826.784 588.921 1095.15C573.31 1338.31 758.024 1548.53 999.936 1556H1000.06C1241.98 1548.53 1426.69 1338.31 1411.08 1095.15C1393.85 826.784 1143.57 658.687 1000.06 436.169V436C1000.06 436.013 1000.05 436.028 1000.04 436.042C1000.04 436.057 1000.03 436.071 1000.02 436.084C1000.01 436.068 999.994 436.054 999.978 436.042C999.963 436.029 999.947 436.016 999.936 436Z"
      fill="currentColor"
    />
  </svg>,
  "LayerLogoSymbol",
);
